function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".rating-aa_svg__cls-2{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "rating-aa_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "rating-aa_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#231f20",
  d: "M0 0h28.35v28.35H0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "rating-aa_svg__cls-2",
  d: "M13.17 19.46h-3l-.7-2.36H4.53l-.7 2.36h-3l4.38-13.3h3.56zM8.5 14.32L7 9l-1.54 5.32zM26.85 19.46h-3l-.7-2.36h-4.94l-.7 2.36h-3l4.37-13.3h3.56zm-4.67-5.14L20.66 9l-1.52 5.28z"
})));

function SvgRatingAa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28.35 28.35"
  }, props), _ref, _ref2);
}

export default SvgRatingAa;